module.exports = __webpack_public_path__ + "img/shiwu0716.e491a6f8.png";